define('plugin/google-reviews/GoogleReviewsPlugin',['require','lib/plugin/PluginAbstract','backbone','plugin/google-reviews/view/GoogleReviewsLayoutView','plugin/google-reviews/model/GoogleReviewsModel','plugin/google-reviews/collection/GoogleReviewsCollection','Config'],function (require) {

    var PluginAbstract = require('lib/plugin/PluginAbstract');
    var Collection = require('backbone').Collection;
    var GoogleReviewsLayoutView = require('plugin/google-reviews/view/GoogleReviewsLayoutView');
    var GoogleReviewsModel = require('plugin/google-reviews/model/GoogleReviewsModel');
    var GoogleReviewsCollection = require('plugin/google-reviews/collection/GoogleReviewsCollection');
    var Config = require('Config');

    return PluginAbstract.extend({

        _googleReviewsModuleRegions: {
            googleReviewsModule: '#sb_google_reviews_module',
        },

        /**
         * Initialize plugin modules
         */
        initModules: function (layout) {
            //let reviewsModel = new GoogleReviewsModel();
            var reviewsCollection = new GoogleReviewsCollection();

            _.each(this._googleReviewsModuleRegions, function (selector, googleReviewsRegion) {
                layout.addRegion(googleReviewsRegion, selector);
            });

            if (layout.googleReviewsModule.$el.length) {
                layout.googleReviewsModule.show(new GoogleReviewsLayoutView({
                    model: reviewsCollection.getMetaModel(),
                    reviewsCollection: reviewsCollection
                }));
                reviewsCollection.load();
            }
        }

    });

});
